import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import { Link } from "react-router";

export const dataAccordion = [
  {
    id: 1,
    title: `چگونه میتوانم کارت فیزیکی  ${toPersianNumber(
      20
    )} کارت را داشته باشم؟`,
    description: (
      <>
        شما میتوانید با مراجعه حضوری به گیشه های {toPersianNumber(20)} کارت
        موجود در محل زندگی خود، کارت فیزیکی خود را دریافت نمایید. لیست گیشه‌های{" "}
        {toPersianNumber(20)} کارت را از{" "}
        <Link to="/locations" style={{ color: "#1976d2" }}>
          اینجا
        </Link>
        ببینید.
      </>
    ),
  },
  {
    id: 2,
    title: `اعتبار دریافتی از  ${toPersianNumber(
      20
    )} کارت را در کجا میتوان استفاده کرد؟`,
    description: (
      <>
        اعتبار دریافتی از سامانه {toPersianNumber(20)} کارت تنها در پذیرنده های
        طرف قرارداد با {toPersianNumber(20)} کارت قابل استفاده میباشد. لیست
        پذیرنده های {toPersianNumber(20)} کارت را از .{" "}
        <Link to="/locations/merchant" style={{ color: "#1976d2" }}>
          اینجا
        </Link>
        ببینید.
      </>
    ),
  },
  {
    id: 3,
    title: `آیا میتوان اعتبار  ${toPersianNumber(
      20
    )} کارت را به صورت پول نقد دریافت کرد؟`,
    description: `خیر. اعتبارات دریافتی در سامانه  ${toPersianNumber(
      20
    )} کارت تنها به صورت موجودی اعتباری در کیف پول اعتباری ${toPersianNumber(
      20
    )} کارت قرار دارد و تنها از طریق دستگاه های کارتخوان پذیرنده ${toPersianNumber(
      20
    )}کارت قابل استفاده میباشد.`,
  },
  {
    id: 4,
    title: "حداقل و حداکثر زمان بازپرداخت اقساط به چه صورت میباشد",
    description: `حداقل زمان بازپرداخت 1 ماه میباشد که در صورت پرداخت 1 ماهه هیچ گونه کارمزدی به اعتبار دریافت شده تعلق نخواهد گرفت. بیشترین زمان بازپرداخت اقساط در ${toPersianNumber(
      20
    )} کارت نیز 12 ماه میباشد.`,
  },
  {
    id: 5,
    title: "در صورت به تعویق افتادن پرداخت اقساط چه اتفاقی می افتد؟",
    description: `در صورتی که اقساط پرداختی شما در سامانه ${toPersianNumber(
      20
    )} کارت به تعویق بیفتد علاوه بر جریمه نقدی ؛ بر سابقه امتیازات کاربر نیز تاثیر گذار خواهد بود. جریمه نقدی دیرکرد اقساط به ازای هر یک هفته 25 هزار ریال خواد بود و این مبلغ برای همه کاربران ثابت میباشد .`,
  },
  {
    id: 6,
    title: "امکان برداشت از کیف پول و واریز به کارت شتابی را ندارم",
    description:
      "برای انتقال وجه از کیف پول بیست کارت به کارت های شتابی؛ در ابتدا باید کارت بانکی خود را در پنل کاربری خود ثبت نمایید. مورد دیگری که باید هنگام برداشت از کیف پول به آن توجه نمایید این است که شما امکان برداشت از کیف پول نقدی خود را دارید و اگر حساب نقدی شما کمتر از 25 هزار ریال باشد, امکان برداشت از کیف پول را نخواهید داشت.",
  },
  {
    id: 7,
    title: "امکان انتقال وجه و کارت به کارت ندارم",
    description:
      "لطفا ابتدا از وصل نبودن فیلتر شکن خود مطمئن شوید و سپس اتصال به شبکه اینترنت را بررسی نمایید. توجه داشته باشید که انتقال وجه تنها از کارت بیست کارت به کارت بیست کارت امکان پذیر میباشد. همچنین ممکن است در تنظیمات اکانت خود؛ مقدار مبلغ قابل برداشت در طول 24 ساعت را کاهش داده باشید.",
  },
  {
    id: 8,
    title: `دلیل کار نکردن کارت فیزیکی ${toPersianNumber(20)} کارت چیست؟`,
    description: `امکان دارد حساب شما به دلیل ایجاد مشکلات مسدود شده باشد و یا کارت شما سوخته باشد. در صورت بروز این مشکل بهتر است به صورت حضوری به یکی از گیشه های معتبر ${toPersianNumber(
      20
    )}کارت مراجعه نمایید.`,
  },
];
